module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "calibre_pb_0"
    }
  }, [_c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00036",
      "title": "[27]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_27"
    }
  })])]), _vm._v(" "), _c('h2', {
    staticClass: "nobreak",
    attrs: {
      "id": "II"
    }
  }, [_vm._v("II"), _c('br', {
    staticClass: "calibre7"
  }), _vm._v(" "), _c('span', {
    staticClass: "smaller"
  }, [_vm._v("HISTORICAL DISCOURSE")])]), _vm._v(" "), _c('p', {
    staticClass: "subheading"
  }, [_vm._v("AT CONCORD, ON THE SECOND CENTENNIAL ANNIVERSARY\nOF THE INCORPORATION OF THE\nTOWN, SEPTEMBER 12, 1835")])]), _vm._v(" "), _c('div', {
    staticClass: "calibre5"
  }, [_c('div', {
    staticClass: "poetry"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('div', {
    staticClass: "verse"
  }, [_vm._v("Bulkeley, Hunt, Willard, Hosmer, Merriam, Flint,")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("Possessed the land which rendered to their toil")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("Hay, corn, roots, hemp, flax, apples, wool and wood.")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("Each of these landlords walked amidst his farm")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("Saying, ‘’Tis mine, my children’s and my name’s.’")])]), _vm._v(" "), _c('div', {
    staticClass: "stanza"
  }, [_c('div', {
    staticClass: "verse"
  }, [_vm._v("Where are these men? Asleep beneath their grounds:")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("And strangers, fond as they, their furrows plough.")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("Earth laughs in flowers, to see her boastful boys")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("Earth-proud, proud of the earth which is not theirs.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00037",
      "title": "[28]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_28"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "calibre5"
  }, [_c('div', {
    staticClass: "poetry"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('div', {
    staticClass: "verse"
  }, [_vm._v("I will have never a noble,")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("No lineage counted great;")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("Fishers and choppers and ploughmen")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("Shall constitute a state.")])]), _vm._v(" "), _c('div', {
    staticClass: "stanza"
  }, [_c('div', {
    staticClass: "verse"
  }, [_vm._v("Lo now! if these poor men")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("Can govern the land and sea")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("And make just laws below the sun,")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("As planets faithful be.")])]), _vm._v(" "), _c('div', {
    staticClass: "stanza"
  }, [_c('div', {
    staticClass: "verse"
  }, [_vm._v("I cause from every creature")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("His proper good to flow:")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("As much as he is and doeth,")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("So much he shall bestow.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00038",
      "title": "[29]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_29"
    }
  })])]), _vm._v(" "), _c('h3', {
    staticClass: "calibre14 sigil_not_in_toc",
    attrs: {
      "id": "pgepubid00039"
    }
  }, [_vm._v("HISTORICAL DISCOURSE")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Fellow citizens")]), _vm._v(": The town of Concord\nbegins, this day, the third century of\nits history. By a common consent, the people\nof New England, for a few years past, as the\nsecond centennial anniversary of each of its early\nsettlements arrived, have seen fit to observe the\nday. You have thought it becoming to commemorate\nthe planting of the first inland town.\nThe sentiment is just, and the practice is wise.\nOur ears shall not be deaf to the voice of time.\nWe will review the deeds of our fathers, and\npass that just verdict on them we expect from\nposterity on our own.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("And yet, in the eternity of Nature, how recent\nour antiquities appear! The imagination is impatient\nof a cycle so short. Who can tell how\nmany thousand years, every day, the clouds\nhave shaded these fields with their purple awning?\nThe river, by whose banks most of us\nwere born, every winter, for ages, has spread its\ncrust of ice over the great meadows which, in\nages, it had formed. But the little society of\nmen who now, for a few years, fish in this river,\nplough the fields it washes, mow the grass and"), _c('span', {
    attrs: {
      "id": "pgepubid00040",
      "title": "[30]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_30"
    }
  })]), _vm._v("\nreap the corn, shortly shall hurry from its banks\nas did their forefathers. “Man’s life,” said the\nWitan to the Saxon king, “is the sparrow that\nenters at a window, flutters round the house,\nand flies out at another, and none knoweth\nwhence he came, or whither he goes.”"), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_4",
      "id": "FNanchor_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[4]")]), _vm._v(" The\nmore reason that we should give to our being\nwhat permanence we can;—that we should\nrecall the Past, and expect the Future.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Yet the race survives whilst the individual\ndies. In the country, without any interference\nof the law, the agricultural life favors the permanence\nof families. Here are still around me\nthe lineal descendants of the first settlers of\nthis town. Here is Blood, Flint, Willard, Meriam,\nWood, Hosmer, Barrett, Wheeler, Jones,\nBrown, Buttrick, Brooks, Stow, Hoar, Heywood,\nHunt, Miles,—the names of the inhabitants\nfor the first thirty years; and the family\nis in many cases represented, when the name is\nnot. If the name of Bulkeley is wanting, the\nhonor you have done me this day, in making\nme your organ, testifies your persevering kindness\nto his blood."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_5",
      "id": "FNanchor_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[5]")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("I shall not be expected, on this occasion, to\nrepeat the details of that oppression which drove\nour fathers out hither. Yet the town of Concord"), _c('span', {
    attrs: {
      "id": "pgepubid00041",
      "title": "[31]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_31"
    }
  })]), _vm._v("\nwas settled by a party of non-conformists,\nimmediately from Great Britain. The best friend\nthe Massachusetts colony had, though much\nagainst his will, was Archbishop Laud in England.\nIn consequence of his famous proclamation\nsetting up certain novelties in the rites of\npublic worship, fifty godly ministers were suspended\nfor contumacy, in the course of two\nyears and a half. Hindered from speaking, some\nof these dared to print the reasons of their dissent,\nand were punished with imprisonment or\nmutilation."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_6",
      "id": "FNanchor_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[6]")]), _vm._v(" This severity brought some of the\nbest men in England to overcome that natural\nrepugnance to emigration which holds the serious\nand moderate of every nation to their own\nsoil. Among the silenced clergymen was a distinguished\nminister of Woodhill, in Bedfordshire,\nRev. Peter Bulkeley, descended from a\nnoble family, honored for his own virtues, his\nlearning and gifts as a preacher, and adding to\nhis influence the weight of a large estate."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_7",
      "id": "FNanchor_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[7]")]), _vm._v(" Persecution\nreadily knits friendship between its\nvictims. Mr. Bulkeley, having turned his estate\ninto money and set his face towards New England,\nwas easily able to persuade a good number\nof planters to join him. They arrived in Boston\nin 1634."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_8",
      "id": "FNanchor_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[8]")]), _vm._v(" Probably there had been a previous"), _c('span', {
    attrs: {
      "id": "pgepubid00042",
      "title": "[32]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_32"
    }
  })]), _vm._v("\ncorrespondence with Governor Winthrop, and\nan agreement that they should settle at Musketaquid.\nWith them joined Mr. Simon Willard,\na merchant from Kent in England. They\npetitioned the General Court for a grant of a\ntownship, and on the 2d of September, 1635,\ncorresponding in New Style to 12th September,\ntwo hundred years ago this day, leave to begin\na plantation at Musketaquid was given to Peter\nBulkeley, Simon Willard, and about twelve\nfamilies more."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_9",
      "id": "FNanchor_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[9]")]), _vm._v(" A month later, Rev. John Jones\nand a large number of settlers destined for the\nnew town arrived in Boston."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_10",
      "id": "FNanchor_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[10]")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("The grant of the General Court was but a preliminary\nstep. The green meadows of Musketaquid\nor "), _c('i', {
    staticClass: "calibre9"
  }, [_vm._v("Grassy Brook")]), _vm._v(" were far up in the woods,\nnot to be reached without a painful and dangerous\njourney through an uninterrupted wilderness.\nThey could cross the Massachusetts or\nCharles River, by the ferry at Newtown; they\ncould go up the river as far as Watertown. But\nthe Indian paths leading up and down the country\nwere a foot broad. They must then plunge\ninto the thicket, and with their axes cut a road for\ntheir teams, with their women and children and\ntheir household stuff, forced to make long circuits\ntoo, to avoid hills and swamps. Edward"), _c('span', {
    attrs: {
      "id": "pgepubid00043",
      "title": "[33]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_33"
    }
  })]), _vm._v("\nJohnson of Woburn has described in an affecting\nnarrative their labors by the way. “Sometimes\npassing through thickets where their hands\nare forced to make way for their bodies’ passage,\nand their feet clambering over the crossed trees,\nwhich when they missed, they sunk into an uncertain\nbottom in water, and wade up to their\nknees, tumbling sometimes higher, sometimes\nlower. At the end of this, they meet a scorching\nplain, yet not so plain but that the ragged\nbushes scratch their legs foully, even to wearing\ntheir stockings to their bare skin in two or three\nhours. Some of them, having no leggins, have\nhad the blood trickle down at every step. And\nin time of summer, the sun casts such a reflecting\nheat from the sweet fern, whose scent is very\nstrong, that some nearly fainted.”"), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_11",
      "id": "FNanchor_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[11]")]), _vm._v(" They slept on\nthe rocks, wherever the night found them. Much\ntime was lost in travelling they knew not whither,\nwhen the sun was hidden by clouds; for “their\ncompass miscarried in crowding through the\nbushes,” and the Indian paths, once lost, they\ndid not easily find.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Johnson, relating undoubtedly what he had\nhimself heard from the pilgrims, intimates that\nthey consumed many days in exploring the country,\nto select the best place for the town. Their"), _c('span', {
    attrs: {
      "id": "pgepubid00044",
      "title": "[34]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_34"
    }
  })]), _vm._v("\nfirst temporary accommodation was rude enough.\n“After they have found a place of abode, they\nburrow themselves in the earth for their first\nshelter, under a hillside, and casting the soil aloft\nupon timbers, they make a fire against the earth,\nat the highest side. And thus these poor servants\nof Christ provide shelter for themselves, their\nwives and little ones, keeping off the short showers\nfrom their lodgings, but the long rains penetrate\nthrough, to their great disturbance in the\nnight season. Yet in these poor wigwams they\nsing psalms, pray and praise their God, till they\ncan provide them houses, which they could not\nordinarily, till the earth, by the Lord’s blessing,\nbrought forth bread to feed them. This they\nattain with sore travail, every one that can lift a\nhoe to strike into the earth standing stoutly to\nhis labors, and tearing up the roots and bushes\nfrom the ground, which, the first year, yielded\nthem a lean crop, till the sod of the earth was\nrotten, and therefore they were forced to cut\ntheir bread very thin for a long season. But the\nLord is pleased to provide for them great store\nof fish in the spring-time, and especially, alewives,\nabout the bigness of a herring.”"), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_12",
      "id": "FNanchor_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[12]")]), _vm._v(" These served\nthem also for manure. For flesh, they looked\nnot for any, in those times, unless they could"), _c('span', {
    attrs: {
      "id": "pgepubid00045",
      "title": "[35]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_35"
    }
  })]), _vm._v("\nbarter with the Indians for venison and raccoons.\n“Indian corn, even the coarsest, made as pleasant\nmeal as rice.”"), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_13",
      "id": "FNanchor_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[13]")]), _vm._v(" All kinds of garden fruits\ngrew well, “and let no man,” writes our pious\nchronicler, in another place, “make a jest of\npumpkins, for with this fruit the Lord was\npleased to feed his people until their corn and\ncattle were increased.”"), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_14",
      "id": "FNanchor_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[14]")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("The great cost of cattle, and the sickening of\ntheir cattle upon such wild fodder as was never\ncut before; the loss of their sheep and swine by\nwolves; the sufferings of the people in the great\nsnows and cold soon following; and the fear of\nthe Pequots; are the other disasters enumerated\nby the historian.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("The hardships of the journey and of the first\nencampment are certainly related by their contemporary\nwith some air of romance, yet they\ncan scarcely be exaggerated. A march of a number\nof families with their stuff, through twenty\nmiles of unknown forest, from a little rising\ntown that had not much to spare, to an Indian\ntown in the wilderness that had nothing, must\nbe laborious to all, and for those who were new\nto the country and bred in softness, a formidable\nadventure. But the pilgrims had the preparation\nof an armed mind, better than any hardihood of"), _c('span', {
    attrs: {
      "id": "pgepubid00046",
      "title": "[36]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_36"
    }
  })]), _vm._v("\nbody. And the rough welcome which the new\nland gave them was a fit introduction to the life\nthey must lead in it.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("But what was their reception at Musketaquid?\nThis was an old village of the Massachusetts\nIndians. Tahattawan, the Sachem, with Waban\nhis son-in-law, lived near Nashawtuck, now Lee’s\nHill."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_15",
      "id": "FNanchor_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[15]")]), _vm._v(" Their tribe, once numerous, the epidemic\nhad reduced. Here they planted, hunted and\nfished. The moose was still trotting in the country,\nand of his sinews they made their bowstring.\nOf the pith elder, that still grows beside our\nbrooks, they made their arrow. Of the Indian\nhemp they spun their nets and lines for summer\nangling, and, in winter, they sat around holes in\nthe ice, catching salmon, pickerel, breams and\nperch, with which our river abounded."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_16",
      "id": "FNanchor_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[16]")]), _vm._v(" Their\nphysical powers, as our fathers found them, and\nbefore yet the English alcohol had proved more\nfatal to them than the English sword, astonished\nthe white men."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_17",
      "id": "FNanchor_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[17]")]), _vm._v(" Their sight was so excellent,\nthat, standing on the seashore, they often told\nof the coming of a ship at sea, sooner by one\nhour, yea, two hours’ sail, than any Englishman\nthat stood by, on purpose to look out."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_18",
      "id": "FNanchor_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[18]")]), _vm._v(" Roger\nWilliams affirms that he has known them run\nbetween eighty and a hundred miles in a summer’s"), _c('span', {
    attrs: {
      "id": "pgepubid00047",
      "title": "[37]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_37"
    }
  })]), _vm._v("\nday, and back again within two days. A\nlittle pounded parched corn or no-cake sufficed\nthem on the march. To his bodily perfection,\nthe wild man added some noble traits of character.\nHe was open as a child to kindness and\njustice. Many instances of his humanity were\nknown to the Englishmen who suffered in the\nwoods from sickness or cold. “When you came\nover the morning waters,” said one of the Sachems,\n“we took you into our arms. We fed\nyou with our best meat. Never went white man\ncold and hungry from Indian wigwam.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("The faithful dealing and brave good will,\nwhich, during the life of the friendly Massasoit,\nthey uniformly experienced at Plymouth and at\nBoston, went to their hearts. So that the peace\nwas made, and the ear of the savage already\nsecured, before the pilgrims arrived at his seat of\nMusketaquid, to treat with him for his lands.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("It is said that the covenant made with the\nIndians, by Mr. Bulkeley and Major Willard,\nwas made under a great oak, formerly standing\nnear the site of the Middlesex Hotel."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_19",
      "id": "FNanchor_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[19]")]), _vm._v(" Our\nRecords affirm that Squaw Sachem, Tahattawan,\nand Nimrod did sell a tract of six miles square to\nthe English, receiving for the same, some fathoms\nof Wampumpeag, hatchets, hoes, knives,"), _c('span', {
    attrs: {
      "id": "pgepubid00048",
      "title": "[38]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_38"
    }
  })]), _vm._v("\ncotton cloth and shirts. Wibbacowet, the husband\nof Squaw Sachem, received a suit of cloth,\na hat, a white linen band, shoes, stockings and\na greatcoat; and, in conclusion, the said Indians\ndeclared themselves satisfied, and told the Englishmen\nthey were welcome. And after the bargain\nwas concluded, Mr. Simon Willard, pointing\nto the four corners of the world, declared that\nthey had bought three miles from that place,\neast, west, north and south."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_20",
      "id": "FNanchor_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[20]")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("The Puritans, to keep the remembrance of\ntheir unity one with another, and of their\npeaceful compact with the Indians, named their\nforest settlement CONCORD. They proceeded\nto build, under the shelter of the hill that\nextends for a mile along the north side of the\nBoston road, their first dwellings. The labors\nof a new plantation were paid by its excitements.\nI seem to see them, with their pious pastor,\naddressing themselves to the work of clearing\nthe land. Natives of another hemisphere, they\nbeheld, with curiosity, all the pleasing features\nof the American forest. The landscape before\nthem was fair, if it was strange and rude. The\nlittle flower which at this season stars our woods\nand roadsides with its profuse blooms, might attract\neven eyes as stern as theirs with its humble"), _c('span', {
    attrs: {
      "id": "pgepubid00049",
      "title": "[39]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_39"
    }
  })]), _vm._v("\nbeauty. The useful pine lifted its cones into the\nfrosty air. The maple, which is already making\nthe forest gay with its orange hues, reddened over\nthose houseless men. The majestic summits of\nWachusett and Monadnoc towering in the horizon,\ninvited the steps of adventure westward.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("As the season grew later, they felt its inconveniences.\n“Many were forced to go barefoot\nand bareleg, and some in time of frost and snow,\nyet were they more healthy than now they are.”"), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_21",
      "id": "FNanchor_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[21]")]), _vm._v("\nThe land was low but healthy; and if, in common\nwith all the settlements, they found the air\nof America very cold, they might say with Higginson,\nafter his description of the other elements,\nthat “New England may boast of the\nelement of fire, more than all the rest; for all\nEurope is not able to afford to make so great\nfires as New England. A poor servant, that is\nto possess but fifty acres, may afford to give\nmore wood for fire as good as the world yields,\nthan many noblemen in England.”"), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_22",
      "id": "FNanchor_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[22]")]), _vm._v(" Many were\ntheir wants, but more their privileges. The\nlight struggled in through windows of oiled\npaper,"), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_23",
      "id": "FNanchor_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[23]")]), _vm._v(" but they read the word of God by it.\nThey were fain to make use of their knees for\na table, but their limbs were their own. Hard\nlabor and spare diet they had, and off wooden"), _c('span', {
    attrs: {
      "id": "pgepubid00050",
      "title": "[40]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_40"
    }
  })]), _vm._v("\ntrenchers, but they had peace and freedom, and\nthe wailing of the tempest in the woods sounded\nkindlier in their ear than the smooth voice of\nthe prelates, at home, in England. “There is no\npeople,” said their pastor to his little flock of\nexiles, “but will strive to excel in something.\nWhat can we excel in, if not in holiness? If we\nlook to number, we are the fewest; if to strength,\nwe are the weakest; if to wealth and riches, we\nare the poorest of all the people of God through\nthe whole world. We cannot excel nor so much\nas equal other people in these things; and if we\ncome short in grace and holiness too, we are the\nmost despicable people under heaven. Strive\nwe, therefore, herein to excel, and suffer not this\ncrown to be taken away from us.”"), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_24",
      "id": "FNanchor_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[24]")]), _vm._v(" The sermon\nfell into good and tender hearts; the people\nconspired with their teacher. Their religion was\nsweetness and peace amidst toil and tears. And,\nas we are informed, “the edge of their appetite\nwas greater to spiritual duties at their first coming,\nin time of wants, than afterwards.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("The original Town Records, for the first\nthirty years, are lost. We have records of marriages\nand deaths, beginning nineteen years after\nthe settlement; and copies of some of the doings\nof the town in regard to territory, of the same"), _c('span', {
    attrs: {
      "id": "pgepubid00051",
      "title": "[41]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_41"
    }
  })]), _vm._v("\ndate. But the original distribution of the land,\nor an account of the principles on which it was\ndivided, are not preserved. Agreeably to the\ncustom of the times, a large portion was reserved\nto the public, and it appears from a petition of\nsome newcomers, in 1643, that a part had been\ndivided among the first settlers without price,\non the single condition of improving it."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_25",
      "id": "FNanchor_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[25]")]), _vm._v(" Other\nportions seem to have been successively divided\noff and granted to individuals, at the rate of\nsixpence or a shilling an acre. But, in the first\nyears, the land would not pay the necessary\npublic charges, and they seem to have fallen\nheavily on the few wealthy planters. Mr. Bulkeley,\nby his generosity, spent his estate, and,\ndoubtless in consideration of his charges, the\nGeneral Court, in 1639, granted him 300 acres\ntowards Cambridge; and to Mr. Spencer, probably\nfor the like reason, 300 acres by the Alewife\nRiver. In 1638, 1200 acres were granted\nto Governor Winthrop, and 1000 to Thomas\nDudley, of the lands adjacent to the town, and\nGovernor Winthrop selected as a building spot\nthe land near the house of Captain Humphrey\nHunt."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_26",
      "id": "FNanchor_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[26]")]), _vm._v(" The first record now remaining is that\nof a reservation of land for the minister, and\nthe appropriation of new lands as commons or"), _c('span', {
    attrs: {
      "id": "pgepubid00052",
      "title": "[42]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_42"
    }
  })]), _vm._v("\npastures to some poor men. At the same date,\nin 1654, the town having divided itself into three\ndistricts, called the North, South and East\nquarters, ordered, “that the North quarter are\nto keep and maintain all their highways and\nbridges over the great river, in their quarter,\nand, in respect of the greatness of their charge\nthereabout, and in regard of the ease of the East\nquarter above the rest, in their highways, they\nare to allow the North quarter £3.”"), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_27",
      "id": "FNanchor_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[27]")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Fellow citizens, this first recorded political\nact of our fathers, this tax assessed on its inhabitants\nby a town, is the most important event\nin their civil history, implying, as it does, the\nexercise of a sovereign power, and connected with\nall the immunities and powers of a corporate\ntown in Massachusetts. The greater speed and\nsuccess that distinguish the planting of the human\nrace in this country, over all other plantations\nin history, owe themselves mainly to the new\nsubdivisions of the State into small corporations\nof land and power. It is vain to look for the inventor.\nNo man made them. Each of the parts\nof that perfect structure grew out of the necessities\nof an instant occasion. The germ was formed\nin England. The charter gave to the freemen\nof the Company of Massachusetts Bay the election"), _c('span', {
    attrs: {
      "id": "pgepubid00053",
      "title": "[43]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_43"
    }
  })]), _vm._v("\nof the Governor and Council of Assistants.\nIt moreover gave them the power of prescribing\nthe manner in which freemen should be elected;\nand ordered that all fundamental laws should be\nenacted by the freemen of the colony. But the\nCompany removed to New England; more than\none hundred freemen were admitted the first\nyear, and it was found inconvenient to assemble\nthem all."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_28",
      "id": "FNanchor_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[28]")]), _vm._v(" And when, presently, the design of\nthe colony began to fulfil itself, by the settlement\nof new plantations in the vicinity of Boston,\nand parties, with grants of land, straggled\ninto the country to truck with the Indians and\nto clear the land for their own benefit, the Governor\nand freemen in Boston found it neither\ndesirable nor possible to control the trade and\npractices of these farmers. What could the body\nof freemen, meeting four times a year, at Boston,\ndo for the daily wants of the planters at Musketaquid?\nThe wolf was to be killed; the Indian\nto be watched and resisted; wells to be dug;\nthe forest to be felled; pastures to be cleared;\ncorn to be raised; roads to be cut; town and farm\nlines to be run. These things must be done,\ngovern who might. The nature of man and his\ncondition in the world, for the first time within\nthe period of certain history, controlled the formation"), _c('span', {
    attrs: {
      "id": "pgepubid00054",
      "title": "[44]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_44"
    }
  })]), _vm._v("\nof the State. The necessity of the colonists\nwrote the law. Their wants, their poverty, their\nmanifest convenience made them bold to ask of\nthe Governor and of the General Court, immunities,\nand, to certain purposes, sovereign powers.\nThe townsmen’s words were heard and weighed,\nfor all knew that it was a petitioner that could\nnot be slighted; it was the river, or the winter,\nor famine, or the Pequots, that spoke through\nthem to the Governor and Council of Massachusetts\nBay. Instructed by necessity, each little\ncompany organized itself after the pattern of\nthe larger town, by appointing its constable,\nand other petty half-military officers. As early\nas 1633,"), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_29",
      "id": "FNanchor_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[29]")]), _vm._v(" the office of townsman or "), _c('i', {
    staticClass: "calibre9"
  }, [_vm._v("selectman")]), _vm._v("\nappears, who seems first to have been appointed\nby the General Court, as here, at Concord, in\n1639. In 1635, the Court say, “whereas particular\ntowns have many things which concern\nonly themselves, it is Ordered, that the freemen\nof every town shall have power to dispose of\ntheir own lands, and woods, and choose their\nown particular officers.”"), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_30",
      "id": "FNanchor_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[30]")]), _vm._v(" This pointed chiefly\nat the office of constable, but they soon chose\ntheir own selectmen, and very early assessed\ntaxes; a power at first resisted,"), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_31",
      "id": "FNanchor_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[31]")]), _vm._v(" but speedily\nconfirmed to them.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00055",
      "title": "[45]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_45"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Meantime, to this paramount necessity, a\nmilder and more pleasing influence was joined. I\nesteem it the happiness of this country that its\nsettlers, whilst they were exploring their granted\nand natural rights and determining the power\nof the magistrate, were united by personal affection.\nMembers of a church before whose searching\ncovenant all rank was abolished, they stood\nin awe of each other, as religious men. They\nbore to John Winthrop, the Governor, a grave\nbut hearty kindness. For the first time, men\nexamined the powers of the chief whom they\nloved and revered. For the first time, the ideal\nsocial compact was real. The bands of love and\nreverence held fast the little state, whilst they\nuntied the great cords of authority to examine\ntheir soundness and learn on what wheels they\nran. They were to settle the internal constitution\nof the towns, and, at the same time, their\npower in the commonwealth. The Governor\nconspires with them in limiting his claims to\ntheir obedience, and values much more their\nlove than his chartered authority. The disputes\nbetween that forbearing man and the deputies\nare like the quarrels of girls, so much do they\nturn upon complaints of unkindness, and end\nin such loving reconciliations. It was on doubts"), _c('span', {
    attrs: {
      "id": "pgepubid00056",
      "title": "[46]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_46"
    }
  })]), _vm._v("\nconcerning their own power, that, in 1634, a\ncommittee repaired to him for counsel, and he\nadvised, seeing the freemen were grown so numerous,\nto send deputies from every town once\nin a year to revise the laws and to assess all\nmonies."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_32",
      "id": "FNanchor_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[32]")]), _vm._v(" And the General Court, thus constituted,\nonly needed to go into separate session\nfrom the Council, as they did in 1644,"), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_33",
      "id": "FNanchor_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[33]")]), _vm._v(" to become\nessentially the same assembly they are this day.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("By this course of events, Concord and the\nother plantations found themselves separate and\nindependent of Boston, with certain rights of\ntheir own, which, what they were, time alone\ncould fully determine; enjoying, at the same\ntime, a strict and loving fellowship with Boston,\nand sure of advice and aid, on every emergency.\nTheir powers were speedily settled by obvious\nconvenience, and the towns learned to exercise\na sovereignty in the laying of taxes; in the\nchoice of their deputy to the house of representatives;\nin the disposal of the town lands; in the\ncare of public worship, the school and the poor;\nand, what seemed of at least equal importance,\nto exercise the right of expressing an opinion\non every question before the country. In a\ntown-meeting, the great secret of political science\nwas uncovered, and the problem solved,"), _c('span', {
    attrs: {
      "id": "pgepubid00057",
      "title": "[47]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_47"
    }
  })]), _vm._v("\nhow to give every individual his fair weight in\nthe government, without any disorder from numbers.\nIn a town-meeting, the roots of society\nwere reached. Here the rich gave counsel, but\nthe poor also; and moreover, the just and the\nunjust. He is ill informed who expects, on running\ndown the Town Records for two hundred\nyears, to find a church of saints, a metropolis\nof patriots, enacting wholesome and creditable\nlaws. The constitution of the towns forbid it.\nIn this open democracy, every opinion had utterance;\nevery objection, every fact, every acre of\nland, every bushel of rye, its entire weight. The\nmoderator was the passive mouth-piece, and the\nvote of the town, like the vane on the turret\noverhead, free for every wind to turn, and always\nturned by the last and strongest breath. In these\nassemblies, the public weal, the call of interest,\nduty, religion, were heard; and every local\nfeeling, every private grudge, every suggestion\nof petulance and ignorance, were not less faithfully\nproduced. Wrath and love came up to\ntown-meeting in company. By the law of 1641,\nevery man—freeman or not—inhabitant or\nnot—might introduce any business into a public\nmeeting. Not a complaint occurs in all the\nvolumes of our Records, of any inhabitant being"), _c('span', {
    attrs: {
      "title": "[48]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_48"
    }
  })]), _vm._v("\nhindered from speaking, or suffering from any\nviolence or usurpation of any class. The negative\nballot of a ten-shilling freeholder was as\nfatal as that of the honored owner of Blood’s\nFarms or Willard’s Purchase. A man felt himself\nat liberty to exhibit, at town-meeting, feelings\nand actions that he would have been\nashamed of anywhere but amongst his neighbors.\nIndividual protests are frequent. Peter\nWright [1705] desired his dissent might be recorded\nfrom the town’s grant to John Shepard."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_34",
      "id": "FNanchor_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[34]")]), _vm._v("\nIn 1795, several town-meetings are called, upon\nthe compensation to be made to a few proprietors\nfor land taken in making a bridle-road; and one\nof them demanding large damages, many offers\nwere made him in town-meeting, and refused;\n“which the town thought very unreasonable.”\nThe matters there debated are such as to invite\nvery small considerations. The ill-spelled pages\nof the Town Records contain the result. I shall\nbe excused for confessing that I have set a value\nupon any symptom of meanness and private\npique which I have met with in these antique\nbooks, as proof that justice was done; that if\nthe results of our history are approved as wise\nand good, it was yet a free strife; if the good\ncounsel prevailed, the sneaking counsel did not"), _c('span', {
    attrs: {
      "id": "pgepubid00058",
      "title": "[49]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_49"
    }
  })]), _vm._v("\nfail to be suggested; freedom and virtue, if they\ntriumphed, triumphed in a fair field. And so\nbe it an everlasting testimony for them, and\nso much ground of assurance of man’s capacity\nfor self-government.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("It is the consequence of this institution that\nnot a school-house, a public pew, a bridge, a\npound, a mill-dam, hath been set up, or pulled\ndown, or altered, or bought, or sold, without\nthe whole population of this town having a\nvoice in the affair. A general contentment is\nthe result. And the people truly feel that they\nare lords of the soil. In every winding road, in\nevery stone fence, in the smokes of the poor-house\nchimney, in the clock on the church, they\nread their own power, and consider, at leisure,\nthe wisdom and error of their judgments.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("The British government has recently presented\nto the several public libraries of this\ncountry, copies of the splendid edition of the\nDomesday Book, and other ancient public records\nof England. I cannot but think that it\nwould be a suitable acknowledgment of this\nnational munificence, if the records of one of\nour towns,—of this town, for example,—should\nbe printed, and presented to the governments\nof Europe; to the English nation, as"), _c('span', {
    attrs: {
      "id": "pgepubid00059",
      "title": "[50]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_50"
    }
  })]), _vm._v("\na thank-offering, and as a certificate of the progress\nof the Saxon race; to the Continental nations\nas a lesson of humanity and love. Tell\nthem, the Union has twenty-four States, and\nMassachusetts is one. Tell them, Massachusetts\nhas three hundred towns, and Concord is\none; that in Concord are five hundred ratable\npolls, and every one has an equal vote.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("About ten years after the planting of Concord,\nefforts began to be made to civilize the\nIndians, and “to win them to the knowledge of\nthe true God.” This indeed, in so many words,\nis expressed in the charter of the colony as one\nof its ends; and this design is named first in\nthe printed “Considerations,”"), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_35",
      "id": "FNanchor_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[35]")]), _vm._v(" that inclined\nHampden, and determined Winthrop and his\nfriends, to come hither. The interest of the\nPuritans in the natives was heightened by a\nsuspicion at that time prevailing that these were\nthe lost ten tribes of Israel. The man of the\nwoods might well draw on himself the compassion\nof the planters. His erect and perfect\nform, though disclosing some irregular virtues,\nwas found joined to a dwindled soul. Master\nof all sorts of wood-craft, he seemed a part of\nthe forest and the lake, and the secret of his\namazing skill seemed to be that he partook of"), _c('span', {
    attrs: {
      "id": "pgepubid00060",
      "title": "[51]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_51"
    }
  })]), _vm._v("\nthe nature and fierce instincts of the beasts he\nslew. Those who dwelled by ponds and rivers\nhad some tincture of civility, but the hunters of\nthe tribe were found intractable at catechism.\nThomas Hooker anticipated the opinion of\nHumboldt, and called them “the ruins of mankind.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Early efforts were made to instruct them, in\nwhich Mr. Bulkeley, Mr. Flint, and Captain\nWillard, took an active part. In 1644, Squaw\nSachem, the widow of Nanepashemet, the great\nSachem of Concord and Mystic, with two sachems\nof Wachusett, made a formal submission\nto the English government, and intimated their\ndesire, “as opportunity served, and the English\nlived among them, to learn to read God’s word,\nand know God aright;” and the General Court\nacted on their request."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_36",
      "id": "FNanchor_36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[36]")]), _vm._v(" John Eliot, in October,\n1646, preached his first sermon in the Indian\nlanguage at Noonantum; Waban, Tahattawan,\nand their sannaps, going thither from Concord\nto hear him. There under the rubbish and ruins\nof barbarous life, the human heart heard the\nvoice of love, and awoke as from a sleep. The\nquestions which the Indians put betray their\nreason and their ignorance. “Can Jesus Christ\nunderstand prayers in the Indian language?”"), _c('span', {
    attrs: {
      "id": "pgepubid00061",
      "title": "[52]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_52"
    }
  })]), _vm._v("\n“If a man be wise, and his sachem weak, must\nhe obey him?” At a meeting which Eliot gave\nto the squaws apart, the wife of Wampooas\npropounded the question, “Whether do I pray\nwhen my husband prays, if I speak nothing\nas he doth, yet if I like what he saith?”—“which\nquestions were accounted of by some,\nas part of the whitenings of the harvest toward.”"), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_37",
      "id": "FNanchor_37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[37]")]), _vm._v("\nTahattawan, our Concord sachem,\ncalled his Indians together, and bid them not\noppose the courses which the English were\ntaking for their good; for, said he, all the time\nyou have lived after the Indian fashion, under\nthe power of the higher sachems, what did they\ncare for you? They took away your skins, your\nkettles and your wampum, at their own pleasure,\nand this was all they regarded. But you\nmay see the English mind no such things, but\nonly seek your welfare, and instead of taking\naway, are ready to give to you. Tahattawan\nand his son-in-law Waban, besought Eliot to\ncome and preach to them at Concord, and here\nthey entered, by his assistance, into an agreement\nto twenty-nine rules, all breathing a desire\nto conform themselves to English customs."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_38",
      "id": "FNanchor_38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[38]")]), _vm._v("\nThey requested to have a town given\nthem within the bounds of Concord, near unto"), _c('span', {
    attrs: {
      "id": "pgepubid00062",
      "title": "[53]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_53"
    }
  })]), _vm._v("\nthe English. When this question was propounded\nby Tahattawan, he was asked, why\nhe desired a town so near, when there was more\nroom for them up in the country? The sachem\nreplied that he knew if the Indians dwelt far\nfrom the English, they would not so much care\nto pray, nor could they be so ready to hear the\nword of God, but would be, all one, Indians\nstill; but dwelling near the English, he hoped\nit might be otherwise with them then. We,\nwho see in the squalid remnants of the twenty\ntribes of Massachusetts, the final failure of this\nbenevolent enterprise, can hardly learn without\nemotion the earnestness with which the most\nsensible individuals of the copper race held on\nto the new hope they had conceived, of being\nelevated to equality with their civilized brother.\nIt is piteous to see their self-distrust in their request\nto remain near the English, and their unanimous\nentreaty to Captain Willard, to be their\nRecorder, being very solicitous that what they\ndid agree upon might be faithfully kept without\nalteration. It was remarkable that the preaching\nwas not wholly new to them. “Their forefathers,”\nthe Indians told Eliot, “did know God, but\nafter this, they fell into a deep sleep, and when\nthey did awake, they quite forgot him.”"), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_39",
      "id": "FNanchor_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[39]")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00063",
      "title": "[54]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_54"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("At the instance of Eliot, in 1651, their desire\nwas granted by the General Court, and Nashobah,\nlying near Nagog Pond, now partly in Littleton,\npartly in Acton, became an Indian town, where\na Christian worship was established under an\nIndian ruler and teacher. Wilson relates that,\nat their meetings, “the Indians sung a psalm,\nmade Indian by Eliot, in one of our ordinary\nEnglish tunes, melodiously.”"), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_40",
      "id": "FNanchor_40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[40]")]), _vm._v(" Such was, for half\na century, the success of the general enterprise,\nthat, in 1676, there were five hundred and sixty-seven\npraying Indians, and in 1689, twenty-four\nIndian preachers, and eighteen assemblies.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Meantime, Concord increased in territory and\npopulation. The lands were divided; highways\nwere cut from farm to farm, and from this town\nto Boston. A military company had been organized\nin 1636. The Pequots, the terror of\nthe farmer, were exterminated in 1637. Captain\nUnderhill, in 1638, declared, that “the new\nplantations of Dedham and Concord do afford\nlarge accommodation, and will contain abundance\nof people.”"), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_41",
      "id": "FNanchor_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[41]")]), _vm._v(" In 1639, our first selectmen, Mr.\nFlint, Lieutenant Willard, and Richard Griffin\nwere appointed. And in 1640, when the colony\nrate was £1200, Concord was assessed £50."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_42",
      "id": "FNanchor_42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[42]")]), _vm._v("\nThe country already began to yield more than"), _c('span', {
    attrs: {
      "id": "pgepubid00064",
      "title": "[55]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_55"
    }
  })]), _vm._v("\nwas consumed by the inhabitants."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_43",
      "id": "FNanchor_43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[43]")]), _vm._v(" The very\ngreat immigration from England made the lands\nmore valuable every year, and supplied a market\nfor the produce. In 1643, the colony was so\nnumerous that it became expedient to divide it\ninto four counties, Concord being included in\nMiddlesex."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_44",
      "id": "FNanchor_44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[44]")]), _vm._v(" In 1644, the town contained sixty\nfamilies.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("But, in 1640, all immigration ceased, and the\ncountry produce and farm-stock depreciated."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_45",
      "id": "FNanchor_45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[45]")]), _vm._v("\nOther difficulties accrued. The fish, which had\nbeen the abundant manure of the settlers, was\nfound to injure the land."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_46",
      "id": "FNanchor_46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[46]")]), _vm._v(" The river, at this\nperiod, seems to have caused some distress now\nby its overflow, now by its drought."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_47",
      "id": "FNanchor_47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[47]")]), _vm._v(" A cold and\nwet summer blighted the corn; enormous flocks\nof pigeons beat down and eat up all sorts of\nEnglish grain; and the crops suffered much from\nmice."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_48",
      "id": "FNanchor_48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[48]")]), _vm._v(" New plantations and better land had been\nopened, far and near; and whilst many of the\ncolonists at Boston thought to remove, or did\nremove to England, the Concord people became\nuneasy, and looked around for new seats. In\n1643, one seventh or one eighth part of the\ninhabitants went to Connecticut with Reverend\nMr. Jones, and settled Fairfield. Weakened by\nthis loss, the people begged to be released from"), _c('span', {
    attrs: {
      "id": "pgepubid00065",
      "title": "[56]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_56"
    }
  })]), _vm._v("\na part of their rates, to which the General Court\nconsented. Mr. Bulkeley dissuaded his people\nfrom removing, and admonished them to increase\ntheir faith with their griefs. Even this check\nwhich befell them acquaints us with the rapidity\nof their growth, for the good man, in dealing\nwith his people, taxes them with luxury. “We\npretended to come hither,” he says, “for ordinances;\nbut now ordinances are light matters\nwith us; we are turned after the prey. We have\namong us excess and pride of life; pride in\napparel, daintiness in diet, and that in those who,\nin times past, would have been satisfied with\nbread. "), _c('i', {
    staticClass: "calibre9"
  }, [_vm._v("This is the sin of the lowest of the people.")]), _vm._v("”"), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_49",
      "id": "FNanchor_49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[49]")]), _vm._v("\nBetter evidence could not be desired of the rapid\ngrowth of the settlement.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("The check was but momentary. The earth\nteemed with fruits. The people on the bay built\nships, and found the way to the West Indies,\nwith pipe-staves, lumber and fish; and the country\npeople speedily learned to supply themselves\nwith sugar, tea and molasses. The college had\nbeen already gathered in 1638. Now the school-house\nwent up. The General Court, in 1647,\n“to the end that learning may not be buried in\nthe graves of our forefathers, Ordered, that every\ntownship, after the Lord had increased them to"), _c('span', {
    attrs: {
      "id": "pgepubid00066",
      "title": "[57]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_57"
    }
  })]), _vm._v("\nthe number of fifty house-holders, shall appoint\none to teach all children to write and read; and\nwhere any town shall increase to the number of\none hundred families, they shall set up a Grammar\nschool, the masters thereof being able to\ninstruct youth so far as they may be fitted for\nthe University.” With these requirements Concord\nnot only complied, but, in 1653, subscribed\na sum for several years to the support of Harvard\nCollege."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_50",
      "id": "FNanchor_50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[50]")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("But a new and alarming public distress retarded\nthe growth of this, as of the sister towns,\nduring more than twenty years from 1654 to\n1676. In 1654, the four united New England\nColonies agreed to raise 270 foot and 40 horse,\nto reduce Ninigret, Sachem of the Niantics, and\nappointed Major Simon Willard, of this town,\nto the command."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_51",
      "id": "FNanchor_51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[51]")]), _vm._v(" This war seems to have been\npressed by three of the colonies, and reluctantly\nentered by Massachusetts. Accordingly, Major\nWillard did the least he could, and incurred the\ncensure of the Commissioners, who write to their\n“loving friend Major Willard,” “that they leave\nto his consideration the inconveniences arising\nfrom his non-attendance to his commission.”"), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_52",
      "id": "FNanchor_52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[52]")]), _vm._v("\nThis expedition was but the introduction of the\nwar with King Philip. In 1670, the Wampanoags"), _c('span', {
    attrs: {
      "id": "pgepubid00067",
      "title": "[58]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_58"
    }
  })]), _vm._v("\nbegan to grind their hatchets, and mend their\nguns, and insult the English. Philip surrendered\nseventy guns to the Commissioners in Taunton\nMeeting-house,"), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_53",
      "id": "FNanchor_53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[53]")]), _vm._v(" but revenged his humiliation a\nfew years after, by carrying fire and the tomahawk\ninto the English villages. From Narragansett\nto the Connecticut River, the scene of war was\nshifted as fast as these red hunters could traverse\nthe forest. Concord was a military post. The inactivity\nof Major Willard, in Ninigret’s war, had\nlost him no confidence. He marched from Concord\nto Brookfield, in season to save the people\nwhose houses had been burned, and who had\ntaken shelter in a fortified house."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_54",
      "id": "FNanchor_54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[54]")]), _vm._v(" But he fought\nwith disadvantage against an enemy who must\nbe hunted before every battle. Some flourishing\ntowns were burned. John Monoco, a formidable\nsavage, boasted that “he had burned Medfield\nand Lancaster, and would burn Groton, Concord,\nWatertown and Boston;” adding, “what\nme will, me do.” He did burn Groton, but before\nhe had executed the remainder of his threat\nhe was hanged, in Boston, in September, 1676."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_55",
      "id": "FNanchor_55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[55]")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("A still more formidable enemy was removed,\nin the same year, by the capture of Canonchet,\nthe faithful ally of Philip, who was soon afterwards\nshot at Stonington. He stoutly declared"), _c('span', {
    attrs: {
      "id": "pgepubid00068",
      "title": "[59]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_59"
    }
  })]), _vm._v("\nto the Commissioners that “he would not deliver\nup a Wampanoag, nor the paring of a\nWampanoag’s nail,” and when he was told that\nhis sentence was death, he said “he liked it well\nthat he was to die before his heart was soft, or\nhe had spoken anything unworthy of himself.”"), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_56",
      "id": "FNanchor_56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[56]")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("We know beforehand who must conquer in\nthat unequal struggle. The red man may destroy\nhere and there a straggler, as a wild beast\nmay; he may fire a farmhouse, or a village; but\nthe association of the white men and their arts\nof war give them an overwhelming advantage,\nand in the first blast of their trumpet we already\nhear the flourish of victory. I confess what\nchiefly interests me, in the annals of that war,\nis the grandeur of spirit exhibited by a few of\nthe Indian chiefs. A nameless Wampanoag who\nwas put to death by the Mohicans, after cruel\ntortures, was asked by his butchers, during the\ntorture, how he liked the war?—he said, “he\nfound it as sweet as sugar was to Englishmen.”"), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_57",
      "id": "FNanchor_57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[57]")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("The only compensation which war offers for\nits manifold mischiefs, is in the great personal\nqualities to which it gives scope and occasion.\nThe virtues of patriotism and of prodigious\ncourage and address were exhibited on both\nsides, and, in many instances, by women. The"), _c('span', {
    attrs: {
      "id": "pgepubid00069",
      "title": "[60]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_60"
    }
  })]), _vm._v("\nhistorian of Concord has preserved an instance\nof the resolution of one of the daughters of the\ntown. Two young farmers, Abraham and Isaac\nShepherd, had set their sister Mary, a girl of\nfifteen years, to watch whilst they threshed grain\nin the barn. The Indians stole upon her before\nshe was aware, and her brothers were slain. She\nwas carried captive into the Indian country, but,\nat night, whilst her captors were asleep, she\nplucked a saddle from under the head of one\nof them, took a horse they had stolen from\nLancaster, and having girt the saddle on, she\nmounted, swam across the Nashua River, and\nrode through the forest to her home."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_58",
      "id": "FNanchor_58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[58]")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("With the tragical end of Philip, the war\nended. Beleaguered in his own country, his corn\ncut down, his piles of meal and other provision\nwasted by the English, it was only a great thaw\nin January, that, melting the snow and opening\nthe earth, enabled his poor followers to come at\nthe ground-nuts, else they had starved. Hunted\nby Captain Church, he fled from one swamp to\nanother; his brother, his uncle, his sister, and\nhis beloved squaw being taken or slain, he was\nat last shot down by an Indian deserter, as he\nfled alone in the dark of the morning, not far\nfrom his own fort."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_59",
      "id": "FNanchor_59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[59]")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00070",
      "title": "[61]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_61"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Concord suffered little from the war. This is\nto be attributed no doubt, in part, to the fact\nthat troops were generally quartered here, and\nthat it was the residence of many noted soldiers.\nTradition finds another cause in the sanctity of\nits minister. The elder Bulkeley was gone. In\n1659,"), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_60",
      "id": "FNanchor_60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[60]")]), _vm._v(" his bones were laid at rest in the forest.\nBut the mantle of his piety and of the people’s\naffection fell upon his son Edward,"), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_61",
      "id": "FNanchor_61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[61]")]), _vm._v(" the fame of\nwhose prayers, it is said, once saved Concord\nfrom an attack of the Indian."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_62",
      "id": "FNanchor_62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[62]")]), _vm._v(" A great defence\nundoubtedly was the village of Praying Indians,\nuntil this settlement fell a victim to the envenomed\nprejudice against their countrymen. The\nworst feature in the history of those years, is,\nthat no man spake for the Indian. When the\nDutch, or the French, or the English royalist\ndisagreed with the Colony, there was always\nfound a Dutch, or French, or tory party,—an\nearnest minority,—to keep things from extremity.\nBut the Indian seemed to inspire such a\nfeeling as the wild beast inspires in the people\nnear his den. It is the misfortune of Concord\nto have permitted a disgraceful outrage upon\nthe friendly Indians settled within its limits, in\nFebruary, 1676, which ended in their forcible\nexpulsion from the town."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_63",
      "id": "FNanchor_63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[63]")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00071",
      "title": "[62]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_62"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("This painful incident is but too just an example\nof the measure which the Indians have\ngenerally received from the whites. For them\nthe heart of charity, of humanity, was stone.\nAfter Philip’s death, their strength was irrecoverably\nbroken. They never more disturbed the\ninterior settlements, and a few vagrant families,\nthat are now pensioners on the bounty of Massachusetts,\nare all that is left of the twenty tribes.")]), _vm._v(" "), _c('div', {
    staticClass: "calibre5"
  }, [_c('div', {
    staticClass: "poetry"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('div', {
    staticClass: "verse"
  }, [_vm._v("“Alas! for them—their day is o’er,")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("Their fires are out from hill and shore,")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("No more for them the wild deer bounds,")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("The plough is on their hunting grounds;")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("The pale man’s axe rings in their woods,")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("The pale man’s sail skims o’er their floods,")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("Their pleasant springs are dry.”"), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_64",
      "id": "FNanchor_64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[64]")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("I turn gladly to the progress of our civil history.\nBefore 1666, 15,000 acres had been added\nby grants of the General Court to the original\nterritory of the town,"), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_65",
      "id": "FNanchor_65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[65]")]), _vm._v(" so that Concord then included\nthe greater part of the towns of Bedford,\nActon, Lincoln and Carlisle.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("In the great growth of the country, Concord\nparticipated, as is manifest from its increasing\npolls and increased rates. Randolph at this\nperiod writes to the English government, concerning\nthe country towns; “The farmers are"), _c('span', {
    attrs: {
      "id": "pgepubid00072",
      "title": "[63]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_63"
    }
  })]), _vm._v("\nnumerous and wealthy, live in good houses; are\ngiven to hospitality; and make good advantage\nby their corn, cattle, poultry, butter and cheese.”"), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_66",
      "id": "FNanchor_66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[66]")]), _vm._v("\nEdward Bulkeley was the pastor, until his death,\nin 1696. His youngest brother, Peter, was deputy\nfrom Concord, and was chosen speaker of\nthe house of deputies in 1676. The following\nyear, he was sent to England, with Mr. Stoughton,\nas agent for the Colony; and on his return,\nin 1685, was a royal councillor. But I am sorry\nto find that the servile Randolph speaks of him\nwith marked respect."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_67",
      "id": "FNanchor_67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[67]")]), _vm._v(" It would seem that his visit\nto England had made him a courtier. In 1689,\nConcord partook of the general indignation of the\nprovince against Andros. A company marched\nto the capital under Lieutenant Heald, forming\na part of that body concerning which we are\ninformed, “the country people came armed into\nBoston, on the afternoon (of Thursday, 18th\nApril) in such rage and heat, as made us all\ntremble to think what would follow; for nothing\nwould satisfy them but that the governor must be\nbound in chains or cords, and put in a more secure\nplace, and that they would see done before they\nwent away; and to satisfy them he was guarded by\nthem to the fort.”"), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_68",
      "id": "FNanchor_68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[68]")]), _vm._v(" But the Town Records of that\nday confine themselves to descriptions of lands,"), _c('span', {
    attrs: {
      "id": "pgepubid00073",
      "title": "[64]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_64"
    }
  })]), _vm._v("\nand to conferences with the neighboring towns to\nrun boundary lines. In 1699, so broad was their\nterritory, I find the selectmen running the lines\nwith Chelmsford, Cambridge and Watertown."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_69",
      "id": "FNanchor_69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[69]")]), _vm._v("\nSome interesting peculiarities in the manners and\ncustoms of the time appear in the town’s books.\nProposals of marriage were made by the parents\nof the parties, and minutes of such private agreements\nsometimes entered on the clerk’s records."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_70",
      "id": "FNanchor_70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[70]")]), _vm._v("\nThe public charity seems to have been bestowed\nin a manner now obsolete. The town lends its\ncommons as pastures, to poor men; and “being\ninformed of the great present want of Thomas\nPellit, gave order to Stephen Hosmer to deliver\na town cow, of a black color, with a white face,\nunto said Pellit, for his present supply.”"), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_71",
      "id": "FNanchor_71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[71]")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("From the beginning to the middle of the eighteenth\ncentury, our records indicate no interruption\nof the tranquillity of the inhabitants, either\nin church or in civil affairs. After the death of\nRev. Mr. Estabrook, in 1711, it was propounded\nat the town-meeting, “whether one of the three\ngentlemen lately improved here in preaching,\nnamely, Mr. John Whiting, Mr. Holyoke and\nMr. Prescott, shall be now chosen in the work\nof the ministry? Voted affirmatively.”"), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_72",
      "id": "FNanchor_72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[72]")]), _vm._v(" Mr.\nWhiting, who was chosen, was, we are told in"), _c('span', {
    attrs: {
      "id": "pgepubid00074",
      "title": "[65]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_65"
    }
  })]), _vm._v("\nhis epitaph, “a universal lover of mankind.”\nThe charges of education and of legislation, at\nthis period, seem to have afflicted the town; for\nthey vote to petition the General Court to be\neased of the law relating to providing a schoolmaster;\nhappily, the Court refused; and in 1712,\nthe selectmen agreed with Captain James Minott,\n“for his son Timothy to keep the school at the\nschool-house for the town of Concord, for half\na year beginning 2d June; and if any scholar\nshall come, within the said time, for larning exceeding\nhis son’s ability, the said Captain doth\nagree to instruct them himself in the tongues,\ntill the above said time be fulfilled; for which\nservice, the town is to pay Captain Minott ten\npounds.”"), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_73",
      "id": "FNanchor_73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[73]")]), _vm._v(" Captain Minott seems to have served\nour prudent fathers in the double capacity of\nteacher and representative. It is an article in the\nselectmen’s warrant for the town-meeting, “to\nsee if the town will lay in for a representative\nnot exceeding four pounds.” Captain Minott\nwas chosen, and after the General Court was\nadjourned received of the town for his services,\nan allowance of three shillings per day. The\ncountry was not yet so thickly settled but that\nthe inhabitants suffered from wolves and wild-cats,\nwhich infested the woods; since bounties of"), _c('span', {
    attrs: {
      "id": "pgepubid00075",
      "title": "[66]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_66"
    }
  })]), _vm._v("\ntwenty shillings are given as late as 1735, to Indians\nand whites, for the heads of these animals,\nafter the constable has cut off the ears."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_74",
      "id": "FNanchor_74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[74]")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Mr. Whiting was succeeded in the pastoral\noffice by Rev. Daniel Bliss, in 1738. Soon after\nhis ordination, the town seems to have been\ndivided by ecclesiastical discords. In 1741, the\ncelebrated Whitfield preached here, in the open\nair, to a great congregation."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_75",
      "id": "FNanchor_75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[75]")]), _vm._v(" Mr. Bliss heard\nthat great orator with delight, and by his earnest\nsympathy with him, in opinion and practice, gave\noffence to a part of his people. Party and mutual\ncouncils were called, but no grave charge\nwas made good against him. I find, in the\nChurch Records, the charges preferred against\nhim, his answer thereto, and the result of the\nCouncil. The charges seem to have been made\nby the lovers of order and moderation against\nMr. Bliss, as a favorer of religious excitements.\nHis answer to one of the counts breathes such\ntrue piety that I cannot forbear to quote it. The\nninth allegation is “That in praying for himself,\nin a church-meeting, in December last, he said,\n‘he was a poor vile worm of the dust, that was\nallowed as Mediator between God and this people.’”\nTo this Mr. Bliss replied, “In the prayer\nyou speak of, Jesus Christ was acknowledged as"), _c('span', {
    attrs: {
      "id": "pgepubid00076",
      "title": "[67]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_67"
    }
  })]), _vm._v("\nthe only Mediator between God and man; at\nwhich time, I was filled with wonder, that such\na sinful and worthless worm as I am, was allowed\nto represent Christ, in any manner, even so far\nas to be bringing the petitions and thank-offerings\nof the people unto God, and God’s will\nand truths to the people; and used the word\nMediator in some differing light from that you\nhave given it; but I confess I was soon uneasy\nthat I had used the word, lest some would put\na wrong meaning thereupon.”"), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_76",
      "id": "FNanchor_76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[76]")]), _vm._v(" The Council\nadmonished Mr. Bliss of some improprieties of\nexpression, but bore witness to his purity and\nfidelity in his office. In 1764, Whitfield preached\nagain at Concord, on Sunday afternoon; Mr.\nBliss preached in the morning, and the Concord\npeople thought their minister gave them the\nbetter sermon of the two. It was also his last."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_77",
      "id": "FNanchor_77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[77]")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("The planting of the colony was the effect of\nreligious principle. The Revolution was the fruit\nof another principle,—the devouring thirst for\njustice. From the appearance of the article in\nthe Selectmen’s warrant, in 1765, “to see if the\ntown will give the Representative any instructions\nabout any important affair to be transacted\nby the General Court, concerning the Stamp\nAct,”"), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_78",
      "id": "FNanchor_78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[78]")]), _vm._v(" to the peace of 1783, the Town Records"), _c('span', {
    attrs: {
      "id": "pgepubid00077",
      "title": "[68]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_68"
    }
  })]), _vm._v("\nbreathe a resolute and warlike spirit, so bold\nfrom the first as hardly to admit of increase.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("It would be impossible on this occasion to\nrecite all these patriotic papers. I must content\nmyself with a few brief extracts. On the 24th\nJanuary, 1774, in answer to letters received from\nthe united committees of correspondence, in the\nvicinity of Boston, the town say:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“We cannot possibly view with indifference\nthe past and present obstinate endeavors of the\nenemies of this, as well as the mother country,\nto rob us of those rights, that are the distinguishing\nglory and felicity of this land; rights,\nthat we are obliged to no power, under heaven,\nfor the enjoyment of; as they are the fruit of\nthe heroic enterprises of the first settlers of these\nAmerican colonies. And though we cannot but\nbe alarmed at the great majority, in the British\nparliament, for the imposition of unconstitutional\ntaxes on the colonies, yet, it gives life and strength\nto every attempt to oppose them, that not only\nthe people of this, but the neighboring provinces\nare remarkably united in the important and interesting\nopposition, which, as it succeeded before,\nin some measure, by the blessing of heaven,\nso, we cannot but hope it will be attended with\nstill greater success, in future.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00078",
      "title": "[69]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_69"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“"), _c('i', {
    staticClass: "calibre9"
  }, [_vm._v("Resolved")]), _vm._v(", That these colonies have been and\nstill are illegally taxed by the British parliament,\nas they are not virtually represented therein.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“That the purchasing commodities subject\nto such illegal taxation is an explicit, though an\nimpious and sordid resignation of the liberties\nof this free and happy people.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“That, as the British parliament have empowered\nthe East India Company to export their\ntea into America, for the sole purpose of raising\na revenue from hence; to render the design\nabortive, we will not, in this town, either by ourselves,\nor any from or under us, buy, sell, or use\nany of the East India Company’s tea, or any\nother tea, whilst there is a duty for raising a\nrevenue thereon in America; neither will we\nsuffer any such tea to be used in our families.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“That all such persons as shall purchase, sell,\nor use any such tea, shall, for the future, be\ndeemed unfriendly to the happy constitution of\nthis country.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“That, in conjunction with our brethren in\nAmerica, we will risk our fortunes, and even our\nlives, in defence of his majesty, King George\nthe Third, his person, crown and dignity; and\nwill, also, with the same resolution, as his freeborn\nsubjects in this country, to the utmost of"), _c('span', {
    attrs: {
      "id": "pgepubid00079",
      "title": "[70]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_70"
    }
  })]), _vm._v("\nour power, defend all our rights inviolate to the\nlatest posterity.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“That, if any person or persons, inhabitants\nof this province, so long as there is a duty on\ntea, shall import any tea from the India House,\nin England, or be factors for the East India\nCompany, we will treat them, in an eminent\ndegree, as enemies to their country, and with\ncontempt and detestation.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“That we think it our duty, at this critical\ntime of our public affairs, to return our hearty\nthanks to the town of Boston, for every rational\nmeasure they have taken for the preservation\nor recovery of our invaluable rights and\nliberties infringed upon; and we hope, should\nthe state of our public affairs require it, that\nthey will still remain watchful and persevering;\nwith a steady zeal to espy out everything that\nshall have a tendency to subvert our happy constitution.”"), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_79",
      "id": "FNanchor_79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[79]")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("On the 27th June, near three hundred persons,\nupwards of twenty-one years of age, inhabitants\nof Concord, entered into a covenant,\n“solemnly engaging with each other, in the\npresence of God, to suspend all commercial\nintercourse with Great Britain, until the act for\nblocking the harbor of Boston be repealed; and"), _c('span', {
    attrs: {
      "id": "pgepubid00080",
      "title": "[71]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_71"
    }
  })]), _vm._v("\nneither to buy nor consume any merchandise\nimported from Great Britain, nor to deal with\nthose who do.”"), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_80",
      "id": "FNanchor_80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[80]")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("In August, a County Convention met in this\ntown, to deliberate upon the alarming state of\npublic affairs, and published an admirable report."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_81",
      "id": "FNanchor_81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[81]")]), _vm._v("\nIn September, incensed at the new royal\nlaw which made the judges dependent on the\ncrown, the inhabitants assembled on the common,\nand forbade the justices to open the court\nof sessions. This little town then assumed the\nsovereignty. It was judge and jury and council\nand king. On the 26th of the month, the\nwhole town resolved itself into a committee of\nsafety, “to suppress all riots, tumults, and disorders\nin said town, and to aid all untainted\nmagistrates in the execution of the laws of the\nland.” It was then voted, to raise one or more\ncompanies of minute-men, by enlistment, to\nbe paid by the town whenever called out of\ntown; and to provide arms and ammunition,\n“that those who are unable to purchase them\nthemselves, may have the advantage of them, if\nnecessity calls for it.” In October, the Provincial\nCongress met in Concord. John Hancock\nwas President. This body was composed of the\nforemost patriots, and adopted those efficient"), _c('span', {
    attrs: {
      "id": "pgepubid00081",
      "title": "[72]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_72"
    }
  })]), _vm._v("\nmeasures whose progress and issue belong to\nthe history of the nation."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_82",
      "id": "FNanchor_82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[82]")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("The clergy of New England were, for the\nmost part, zealous promoters of the Revolution.\nA deep religious sentiment sanctified the thirst\nfor liberty. All the military movements in this\ntown were solemnized by acts of public worship.\nIn January, 1775, a meeting was held for\nthe enlisting of minute-men. Reverend William\nEmerson, the chaplain of the Provincial Congress,\npreached to the people. Sixty men enlisted\nand, in a few days, many more. On 13th\nMarch, at a general review of all the military\ncompanies, he preached to a very full assembly,\ntaking for his text, 2 Chronicles xiii. 12, “And,\nbehold, God himself is with us for our captain,\nand his priests with sounding trumpets to cry\nalarm against you.”"), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_83",
      "id": "FNanchor_83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[83]")]), _vm._v(" It is said that all the\nservices of that day made a deep impression on\nthe people, even to the singing of the psalm.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("A large amount of military stores had been\ndeposited in this town, by order of the Provincial\nCommittee of Safety. It was to destroy\nthose stores that the troops who were attacked\nin this town, on the 19th April, 1775, were sent\nhither by General Gage.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("The story of that day is well known. In"), _c('span', {
    attrs: {
      "id": "pgepubid00082",
      "title": "[73]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_73"
    }
  })]), _vm._v("\nthese peaceful fields, for the first time since a\nhundred years, the drum and alarm-gun were\nheard, and the farmers snatched down their\nrusty firelocks from the kitchen walls, to make\ngood the resolute words of their town debates.\nIn the field where the western abutment of the\nold bridge may still be seen, about half a mile\nfrom this spot, the first organized resistance was\nmade to the British arms. There the Americans\nfirst shed British blood. Eight hundred British\nsoldiers, under the command of Lieutenant-Colonel\nFrancis Smith, had marched from Boston\nto Concord; at Lexington had fired upon\nthe brave handful of militia, for which a speedy\nrevenge was reaped by the same militia in the\nafternoon. When they entered Concord, they\nfound the militia and minute-men assembled\nunder the command of Colonel Barrett and\nMajor Buttrick. This little battalion, though in\ntheir hasty council some were urgent to stand\ntheir ground, retreated before the enemy to the\nhigh land on the other bank of the river, to wait\nfor reinforcement. Colonel Barrett ordered the\ntroops not to fire, unless fired upon. The British\nfollowing them across the bridge, posted two\ncompanies, amounting to about one hundred\nmen, to guard the bridge, and secure the return"), _c('span', {
    attrs: {
      "title": "[74]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_74"
    }
  })]), _vm._v("\nof the plundering party. Meantime, the men of\nActon, Bedford, Lincoln and Carlisle, all once\nincluded in Concord, remembering their parent\ntown in the hour of danger, arrived and fell\ninto the ranks so fast, that Major Buttrick\nfound himself superior in number to the enemy’s\nparty at the bridge. And when the smoke\nbegan to rise from the village where the British\nwere burning cannon-carriages and military\nstores, the Americans resolved to force their\nway into town. The English beginning to pluck\nup some of the planks of the bridge, the Americans\nquickened their pace, and the British fired\none or two shots up the river (our ancient\nfriend here, Master Blood,"), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_84",
      "id": "FNanchor_84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[84]")]), _vm._v(" saw the water struck\nby the first ball); then a single gun, the ball\nfrom which wounded Luther Blanchard and\nJonas Brown, and then a volley, by which Captain\nIsaac Davis and Abner Hosmer of Acton\nwere instantly killed. Major Buttrick leaped\nfrom the ground, and gave the command to\nfire, which was repeated in a simultaneous cry\nby all his men. The Americans fired, and killed\ntwo men and wounded eight. A head-stone\nand a foot-stone, on this bank of the river,\nmark the place where these first victims lie."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_85",
      "id": "FNanchor_85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[85]")]), _vm._v("\nThe British retreated immediately towards the"), _c('span', {
    attrs: {
      "id": "pgepubid00083",
      "title": "[75]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_75"
    }
  })]), _vm._v("\nvillage, and were joined by two companies of\ngrenadiers, whom the noise of the firing had\nhastened to the spot. The militia and minute-men—every\none from that moment being his\nown commander—ran over the hills opposite\nthe battle-field, and across the great fields, into\nthe east quarter of the town, to waylay the\nenemy, and annoy his retreat. The British, as\nsoon as they were rejoined by the plundering\ndetachment, began that disastrous retreat to\nBoston, which was an omen to both parties of\nthe event of the war.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("In all the anecdotes of that day’s events we\nmay discern the natural action of the people.\nIt was not an extravagant ebullition of feeling,\nbut might have been calculated on by any one\nacquainted with the spirits and habits of our\ncommunity. Those poor farmers who came up,\nthat day, to defend their native soil, acted from\nthe simplest instincts. They did not know it was\na deed of fame they were doing. These men\ndid not babble of glory. They never dreamed\ntheir children would contend who had done the\nmost. They supposed they had a right to their\ncorn and their cattle, without paying tribute\nto any but their own governors. And as they\nhad no fear of man, they yet did have a fear of"), _c('span', {
    attrs: {
      "id": "pgepubid00084",
      "title": "[76]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_76"
    }
  })]), _vm._v("\nGod. Captain Charles Miles, who was wounded\nin the pursuit of the enemy, told my venerable\nfriend who sits by me, that “he went to the\nservices of that day, with the same seriousness\nand acknowledgment of God, which he carried\nto church.”"), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_86",
      "id": "FNanchor_86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[86]")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("The presence of these aged men who were in\narms on that day seems to bring us nearer to it.\nThe benignant Providence which has prolonged\ntheir lives to this hour gratifies the strong curiosity\nof the new generation. The Pilgrims are\ngone; but we see what manner of persons they\nwere who stood in the worst perils of the Revolution.\nWe hold by the hand the last of the\ninvincible men of old, and confirm from living\nlips the sealed records of time.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("And you, my fathers, whom God and the\nhistory of your country have ennobled, may well\nbear a chief part in keeping this peaceful birthday\nof our town. You are indeed extraordinary\nheroes. If ever men in arms had a spotless cause,\nyou had. You have fought a good fight. And\nhaving quit you like men in the battle, you have\nquit yourselves like men in your virtuous families;\nin your cornfields; and in society. We will\nnot hide your honorable gray hairs under perishing\nlaurel-leaves, but the eye of affection and"), _c('span', {
    attrs: {
      "id": "pgepubid00085",
      "title": "[77]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_77"
    }
  })]), _vm._v("\nveneration follows you. You are set apart—and\nforever—for the esteem and gratitude of the\nhuman race. To you belongs a better badge\nthan stars and ribbons. This prospering country\nis your ornament, and this expanding nation is\nmultiplying your praise with millions of tongues."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_87",
      "id": "FNanchor_87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[87]")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("The agitating events of those days were duly\nremembered in the church. On the second day\nafter the affray, divine service was attended, in\nthis house, by 700 soldiers. William Emerson,\nthe pastor, had a hereditary claim to the affection\nof the people, being descended in the fourth\ngeneration from Edward Bulkeley, son of Peter.\nBut he had merits of his own. The cause of the\nColonies was so much in his heart that he did\nnot cease to make it the subject of his preaching\nand his prayers, and is said to have deeply inspired\nmany of his people with his own enthusiasm.\nHe, at least, saw clearly the pregnant\nconsequences of the 19th April. I have found\nwithin a few days, among some family papers,\nhis almanac of 1775, in a blank leaf of which he\nhas written a narrative of the fight;"), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_88",
      "id": "FNanchor_88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[88]")]), _vm._v(" and at\nthe close of the month, he writes, “This month\nremarkable for the greatest events of the present\nage.” To promote the same cause, he asked,\nand obtained of the town, leave to accept the"), _c('span', {
    attrs: {
      "id": "pgepubid00086",
      "title": "[78]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_78"
    }
  })]), _vm._v("\ncommission of chaplain to the Northern army,\nat Ticonderoga, and died, after a few months,\nof the distemper that prevailed in the camp."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_89",
      "id": "FNanchor_89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[89]")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("In the whole course of the war the town did\nnot depart from this pledge it had given. Its\nlittle population of 1300 souls behaved like a\nparty to the contest. The number of its troops\nconstantly in service is very great. Its pecuniary\nburdens are out of all proportion to its capital.\nThe economy so rigid, which marked its earlier\nhistory, has all vanished. It spends profusely,\naffectionately, in the service. “Since,” say the\nplaintive records, “General Washington, at Cambridge,\nis not able to give but 24s. per cord for\nwood, for the army; it is Voted, that this town\nencourage the inhabitants to supply the army,\nby paying two dollars per cord, over and above\nthe General’s price, to such as shall carry wood\nthither;”"), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_90",
      "id": "FNanchor_90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[90]")]), _vm._v(" and 210 cords of wood were carried.\nA similar order is taken respecting hay. Whilst\nBoston was occupied by the British troops,\nConcord contributed to the relief of the inhabitants,\n£70, in money; 225 bushels of grain;\nand a quantity of meat and wood. When, presently,\nthe poor of Boston were quartered by the\nProvincial Congress on the neighboring country,\nConcord received 82 persons to its hospitality."), _c('span', {
    attrs: {
      "id": "pgepubid00087",
      "title": "[79]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_79"
    }
  })]), _vm._v("\nIn the year 1775, it raised 100 minute-men, and\n74 soldiers to serve at Cambridge. In March,\n1776, 145 men were raised by this town to serve\nat Dorchester Heights."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_91",
      "id": "FNanchor_91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[91]")]), _vm._v(" In June, the General\nAssembly of Massachusetts resolved to raise\n5000 militia for six months, to reinforce the\nContinental army. “The numbers,” say they,\n“are large, but this Court has the fullest assurance\nthat their brethren, on this occasion, will\nnot confer with flesh and blood, but will, without\nhesitation, and with the utmost alacrity and\ndespatch, fill up the numbers proportioned to\nthe several towns.”"), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_92",
      "id": "FNanchor_92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[92]")]), _vm._v(" On that occasion, Concord\nfurnished 67 men, paying them itself, at an\nexpense of £622. And so on, with every levy,\nto the end of the war. For these men it was\ncontinually providing shoes, stockings, shirts,\ncoats, blankets and beef. The taxes, which, before\nthe war, had not much exceeded £200 per\nannum, amounted, in the year 1782, to $9544,\nin silver."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_93",
      "id": "FNanchor_93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[93]")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("The great expense of the war was borne with\ncheerfulness, whilst the war lasted; but years\npassed, after the peace, before the debt was paid.\nAs soon as danger and injury ceased, the people\nwere left at leisure to consider their poverty and\ntheir debts. The Town Records show how slowly"), _c('span', {
    attrs: {
      "id": "pgepubid00088",
      "title": "[80]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_80"
    }
  })]), _vm._v("\nthe inhabitants recovered from the strain of\nexcessive exertion. Their instructions to their\nrepresentatives are full of loud complaints of the\ndisgraceful state of public credit, and the excess\nof public expenditure. They may be pardoned,\nunder such distress, for the mistakes of an extreme\nfrugality. They fell into a common error,\nnot yet dismissed to the moon, that the remedy\nwas, to forbid the great importation of foreign\ncommodities, and to prescribe by law the prices\nof articles. The operation of a new government\nwas dreaded, lest it should prove expensive, and\nthe country towns thought it would be cheaper\nif it were removed from the capital. They were\njealous lest the General Court should pay itself\ntoo liberally, and our fathers must be forgiven\nby their charitable posterity, if, in 1782, before\nchoosing a representative, it was “Voted, that\nthe person who should be chosen representative\nto the General Court should receive 6s. per day,\nwhilst in actual service, an account of which\ntime he should bring to the town, and if it should\nbe that the General Court should resolve, that,\ntheir pay should be more than 6s., then the\nrepresentative shall be hereby directed to pay\nthe overplus into the town treasury.”"), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_94",
      "id": "FNanchor_94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[94]")]), _vm._v(" This was\nsecuring the prudence of the public servants.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00089",
      "title": "[81]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_81"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("But whilst the town had its own full share of\nthe public distress, it was very far from desiring\nrelief at the cost of order and law. In 1786,\nwhen the general sufferings drove the people in\nparts of Worcester and Hampshire counties to\ninsurrection, a large party of armed insurgents\narrived in this town, on the 12th September, to\nhinder the sitting of the Court of Common\nPleas. But they found no countenance here."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_95",
      "id": "FNanchor_95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[95]")]), _vm._v("\nThe same people who had been active in a\nCounty Convention to consider grievances, condemned\nthe rebellion, and joined the authorities\nin putting it down."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_96",
      "id": "FNanchor_96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[96]")]), _vm._v(" In 1787, the admirable\ninstructions given by the town to its representative\nare a proud monument of the good sense\nand good feeling that prevailed. The grievances\nceased with the adoption of the Federal Constitution.\nThe constitution of Massachusetts had\nbeen already accepted. It was put to the town\nof Concord, in October, 1776, by the Legislature,\nwhether the existing house of representatives\nshould enact a constitution for the State?\nThe town answered No."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_97",
      "id": "FNanchor_97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[97]")]), _vm._v(" The General Court,\nnotwithstanding, draughted a constitution, sent\nit here, and asked the town whether they would\nhave it for the law of the State? The town\nanswered No, by a unanimous vote. In 1780, a"), _c('span', {
    attrs: {
      "id": "pgepubid00090",
      "title": "[82]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_82"
    }
  })]), _vm._v("\nconstitution of the State, proposed by the Convention\nchosen for that purpose, was accepted\nby the town with the reservation of some articles."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_98",
      "id": "FNanchor_98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[98]")]), _vm._v("\nAnd, in 1788, the town, by its delegate,\naccepted the new Constitution of the United\nStates, and this event closed the whole series\nof important public events in which this town\nplayed a part.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("From that time to the present hour, this town\nhas made a slow but constant progress in population\nand wealth, and the arts of peace. It has\nsuffered neither from war, nor pestilence, nor\nfamine, nor flagrant crime. Its population, in\nthe census of 1830, was 2020 souls. The public\nexpenses, for the last year, amounted to\n$4290; for the present year, to $5040."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_99",
      "id": "FNanchor_99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[99]")]), _vm._v(" If the\ncommunity stints its expense in small matters, it\nspends freely on great duties. The town raises,\nthis year, $1800 for its public schools; besides\nabout $1200 which are paid, by subscription,\nfor private schools. This year, it expends $800\nfor its poor; the last year it expended $900.\nTwo religious societies, of differing creed, dwell\ntogether in good understanding, both promoting,\nwe hope, the cause of righteousness and\nlove."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_100",
      "id": "FNanchor_100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[100]")]), _vm._v(" Concord has always been noted for its\nministers. The living need no praise of mine."), _c('span', {
    attrs: {
      "id": "pgepubid00091",
      "title": "[83]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_83"
    }
  })]), _vm._v("\nYet it is among the sources of satisfaction and\ngratitude, this day, that the aged with whom\nis wisdom, our fathers’ counsellor and friend, is\nspared to counsel and intercede for the sons."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_101",
      "id": "FNanchor_101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[101]")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Such, fellow citizens, is an imperfect sketch\nof the history of Concord. I have been greatly\nindebted, in preparing this sketch, to the printed\nbut unpublished History of this town, furnished\nme by the unhesitating kindness of its author,\nlong a resident in this place. I hope that History\nwill not long remain unknown. The author\nhas done us and posterity a kindness, by the\nzeal and patience of his research, and has wisely\nenriched his pages with the resolutions, addresses\nand instructions to its agents, which from\ntime to time, at critical periods, the town has\nvoted."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_102",
      "id": "FNanchor_102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[102]")]), _vm._v(" Meantime, I have read with care the\nTown Records themselves. They must ever be\nthe fountains of all just information respecting\nyour character and customs. They are the history\nof the town. They exhibit a pleasing picture\nof a community almost exclusively agricultural,\nwhere no man has much time for words, in his\nsearch after things; of a community of great simplicity\nof manners, and of a manifest love of justice.\nFor the most part, the town has deserved\nthe name it wears. I find our annals marked"), _c('span', {
    attrs: {
      "id": "pgepubid00092",
      "title": "[84]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_84"
    }
  })]), _vm._v("\nwith a uniform good sense. I find no ridiculous\nlaws, no eavesdropping legislators, no hanging\nof witches, no ghosts, no whipping of Quakers,\nno unnatural crimes. The tone of the Records\nrises with the dignity of the event. These soiled\nand musty books are luminous and electric\nwithin. The old town clerks did not spell very\ncorrectly, but they contrive to make pretty intelligible\nthe will of a free and just community.\nFrugal our fathers were,—very frugal,—though,\nfor the most part, they deal generously by their\nminister, and provide well for the schools and\nthe poor. If, at any time, in common with most\nof our towns, they have carried this economy to\nthe verge of a vice, it is to be remembered that\na town is, in many respects, a financial corporation.\nThey economize, that they may sacrifice.\nThey stint and higgle on the price of a pew, that\nthey may send 200 soldiers to General Washington\nto keep Great Britain at bay. For splendor,\nthere must somewhere be rigid economy. That\nthe head of the house may go brave, the members\nmust be plainly clad, and the town must\nsave that the State may spend. Of late years,\nthe growth of Concord has been slow. Without\nnavigable waters, without mineral riches, without\nany considerable mill privileges, the natural increase"), _c('span', {
    attrs: {
      "title": "[85]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_85"
    }
  })]), _vm._v("\nof her population is drained by the constant\nemigration of the youth. Her sons have\nsettled the region around us, and far from us.\nTheir wagons have rattled down the remote\nwestern hills. And in every part of this country,\nand in many foreign parts, they plough the\nearth, they traverse the sea, they engage in trade\nand in all the professions."), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0034#Footnote_103",
      "id": "FNanchor_103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[103]")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Fellow citizens; let not the solemn shadows\nof two hundred years, this day, fall over us in\nvain. I feel some unwillingness to quit the remembrance\nof the past. With all the hope of\nthe new I feel that we are leaving the old. Every\nmoment carries us farther from the two great\nepochs of public principle, the Planting, and the\nRevolution of the colony. Fortunate and favored\nthis town has been, in having received so\nlarge an infusion of the spirit of both of those\nperiods. Humble as is our village in the circle\nof later and prouder towns that whiten the land,\nit has been consecrated by the presence and\nactivity of the purest men. Why need I remind\nyou of our own Hosmers, Minotts, Cumings,\nBarretts, Beattons, the departed benefactors of\nthe town? On the village green have been the\nsteps of Winthrop and Dudley; of John Eliot,\nthe Indian apostle, who had a courage that intimidated"), _c('span', {
    attrs: {
      "id": "pgepubid00093",
      "title": "[86]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_86"
    }
  })]), _vm._v("\nthose savages whom his love could\nnot melt; of Whitfield, whose silver voice melted\nhis great congregation into tears; of Hancock,\nand his compatriots of the Provincial Congress;\nof Langdon, and the college over which he presided.\nBut even more sacred influences than\nthese have mingled here with the stream of\nhuman life. The merit of those who fill a space\nin the world’s history, who are borne forward,\nas it were, by the weight of thousands whom\nthey lead, sheds a perfume less sweet than do the\nsacrifices of private virtue. I have had much\nopportunity of access to anecdotes of families,\nand I believe this town to have been the dwelling-place,\nin all times since its planting, of\npious and excellent persons, who walked meekly\nthrough the paths of common life, who served\nGod, and loved man, and never let go the\nhope of immortality. The benediction of their\nprayers and of their principles lingers around us.\nThe acknowledgment of the Supreme Being\nexalts the history of this people. It brought the\nfathers hither. In a war of principle, it delivered\ntheir sons. And so long as a spark of this\nfaith survives among the children’s children so\nlong shall the name of Concord be honest and\nvenerable.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5e34d0c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0005.vue
// module id = 69
// module chunks = 0